import { create } from 'zustand'
import { AccessControlSite, AccessControlDevice } from './get_all_devices_and_sites'

type AccessControlStoreState = {
    sites: AccessControlSite[]
    devices: AccessControlDevice[]
    setSites: (sites: AccessControlSite[]) => void
    setDevices: (devices: AccessControlDevice[]) => void
    getSites: () => AccessControlSite[]
    getDevices: () => AccessControlDevice[]
}

export const useAccessControlStore = create<AccessControlStoreState>((set, get) => ({
    sites: [],
    devices: [],
    setSites: (sites: AccessControlSite[]) => {
        set(() => ({ sites }))
    },
    setDevices: (devices: AccessControlDevice[]) => {
        set(() => ({ devices }))
    },
    getSites: () => {
        return get().sites
    },
    getDevices: () => {
        return get().devices
    }
}))
